<script setup lang="ts">
import { computed } from "vue";
import { ratingRange, formatValue, type Field } from "@yawhub/core";
import { StarIcon } from "../icons";
import ImageValue from "./ImageValue.vue";
const props = defineProps<{
  field: Field;
  value: unknown;
  bar?: boolean;
  dataset?: string;
  publicBase?: string;
}>();
const range = computed(() => ratingRange(props.field));
const present = computed(
  () => props.value !== null && props.value !== undefined && props.value !== "",
);
</script>
<template>
  <ImageValue
    v-if="field.type === 'image'"
    :value="value"
    :label="field.label"
    :dataset="dataset"
    :public-base="publicBase"
  />
  <span
    v-else-if="
      (bar || (field.ratingStyle && field.ratingStyle !== 'number')) &&
      field.type === 'rating' &&
      present
    "
    class="scale-value"
    role="img"
    :aria-label="`${formatValue(value, field)} på en skala fra ${range.min} til ${range.max}`"
  >
    <span
      v-if="!bar && field.ratingStyle === 'stars'"
      class="scale-stars"
      aria-hidden="true"
    >
      <StarIcon
        v-for="step in range.max - range.min"
        :key="step"
        :size="13"
        :class="{ filled: Number(value) >= range.min + step }"
      />
    </span>
    <span
      v-else
      class="scale-segments"
      :class="{
        dots: !bar && field.ratingStyle === 'dots',
        slider: !bar && field.ratingStyle === 'slider',
      }"
      aria-hidden="true"
    >
      <span
        v-for="step in range.max - range.min"
        :key="step"
        :class="{ filled: Number(value) >= range.min + step }"
      />
    </span>
    <span aria-hidden="true" class="scale-number"
      >{{ value }}<span class="muted"> / {{ range.max }}</span></span
    >
  </span>
  <template v-else>{{ formatValue(value, field) }}</template>
</template>
<style scoped lang="scss" src="../styles/components/ScaleValue.scss"></style>
